const rad = function(x) {
  return (x * Math.PI) / 180
}

export default function sphericalDistance (p1_lat, p1_lon, p2_lat, p2_lon) {
  const R = 6378137 // Earth’s mean radius in meter
  const meterLengthInMiles = 0.0006213712
  var dLat = rad(p2_lat - p1_lat)
  var dLong = rad(p2_lon - p1_lon)
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(p1_lat)) *
      Math.cos(rad(p2_lat)) *
      Math.sin(dLong / 2) *
      Math.sin(dLong / 2)
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  var d = R * c // distance in meters

  return Number(Number(d * meterLengthInMiles).toFixed(2)) // returns the distance in miles
}
